/* トップの売れ筋ランキングのタブ（sections/sc-ranking.liquid）。
   タブの見出しはパネルの data-sc-rank-title から作る（JS が無い時はパネルが全部縦に並ぶだけ）。
   キーボード: 左右・Home・End で移動し、移動した先を選ぶ。 */
(function () {
  function init(root) {
    var tabsEl = root.querySelector('[data-sc-rank-tabs]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sc-rank-panel]'));
    if (!tabsEl || panels.length < 2) return;
    var tabs = panels.map(function (panel, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sc-rank__tab';
      b.setAttribute('role', 'tab');
      b.id = panel.getAttribute('aria-labelledby');
      b.setAttribute('aria-controls', panel.id);
      b.textContent = panel.getAttribute('data-sc-rank-title');
      b.addEventListener('click', function () { select(i, false); });
      tabsEl.appendChild(b);
      return b;
    });
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabsEl.addEventListener('keydown', function (e) {
      var cur = tabs.indexOf(document.activeElement);
      if (cur < 0) return;
      var next = null;
      if (e.key === 'ArrowRight') next = (cur + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (cur - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      select(next, true);
    });
    select(0, false);
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sc-rank-root]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
